import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
/**
 * This essentially behaves as our "global" styles
 * for React UI.
 */
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  .MuiInputBase-input {\n    box-sizing: content-box;\n  }\n"], ["\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  .MuiInputBase-input {\n    box-sizing: content-box;\n  }\n"])));
var templateObject_1;
